/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import util from "../util/util.js";

import "./survey-summary.js";
import "./survey-summary-header.js";

var SurveyViewModel = function(params) {
	var self = this;

	self.loaded = ko.observable(false);
	self.errorMessage = ko.observable(null);

	var surveyID = util.queryParams().id;
	var hash = util.queryParams().h;

	if(!surveyID) {
		console.log("No ID provided");
		return;
	}

	birdata.me(true).catch(function() {
		// That's OK – there might not be a logged in user.
	}).then(function() {
		let params = {};
		if(hash) {
			params.h = hash;
		}
		return birdata.survey(surveyID, params);
	}).then(function(survey) {
		self.survey = ko.observable(survey);
		self.loaded(true);
	}).catch(function(error) {
		self.errorMessage('Unable to load survey');
	});

	self.afterDelete = function() {
		alert("Survey deleted.");
		window.close();
	}
};


ko.components.register('survey', {
	viewModel: function(params) {
		return new SurveyViewModel(params);
	},
	template: require('../../templates/survey.html')
});

export default SurveyViewModel;
